import React from "react";
import { useTranslation } from "react-i18next";

import AppLink from "../../design-system/components/AppLink";
import { LoginSplit, MobileAppNotice, isMobileUA } from "../login";
import "../../i18n";
import "../../design-system/styles/tokens.css";
import "../../design-system/styles/components.css";
import "../login/login.css";

// Landeplatz fuer alle, deren Rolle keinen Web-Zugang hat. Erreichbar aus zwei
// Richtungen: nach abgelehntem Login (403 app_only) und nachdem eine bestehende
// Session am zentralen /api/web-Check haengengeblieben ist.
export default function AppOnly() {
  const { t } = useTranslation();

  return (
    <LoginSplit>
      <MobileAppNotice
        title={t("app_only.title", "TimeTab läuft für dich in der App")}
        subtitle={t(
          "app_only.subtitle",
          "Deine Schichten, Verfügbarkeiten und Stempelzeiten hast du dort immer dabei."
        )}
        showQr={!isMobileUA()}
        qrHint={t("app_only.qr_hint", "Scanne den Code mit deinem Handy:")}
        footer={
          <AppLink size="sm" href="/login">
            {t("app_only.other_account", "Mit einem anderen Konto anmelden")}
          </AppLink>
        }
      />
    </LoginSplit>
  );
}
